// eslint-disable-next-line import/prefer-default-export
export const calculateROI = data => {
  const revenue = parseFloat(data.revenue) || 0;
  const techs = parseFloat(data.techs) || 0;
  const calls = parseFloat(data.calls) || 0;
  const estimates = parseFloat(data.estimates) || 0;
  const leads = parseFloat(data.leads) || 0;
  const jobs = parseFloat(data.jobs) || 0;

  const c6 = calls * 5 * 4.4;
  const c9 = c6 * (leads / 100);
  const c12 = c9 * (estimates / 100);
  const c15 = (jobs / 100) * c12;
  const c18 = revenue * c15;
  const c20 = c18 * 12;
  const e8 = leads + 3;
  const e9 = c6 * (e8 / 100);
  const e11 = estimates + 3;
  const e12 = e9 * (e11 / 100);
  const e14 = jobs + 4;
  const e15 = e12 * (e14 / 100);
  const e17 = revenue + revenue * (1 / 50);
  const e18 = e17 * e15;
  const e20 = e18 * 12;
  const e22 = e20 - c20;
  const e27 = 295 * techs;

  let roiWithST = Math.ceil((Math.ceil(e22 / 12) / e27 - 1) * 100);
  let monthlyRevenueIncrease = (Math.ceil(e22 / 12) / 1000).toFixed(1);
  let annualRevenueIncrease = Math.ceil(((e20 - c20) / c20) * 100);

  roiWithST = `${isFinite(roiWithST) ? roiWithST : 0}%`;
  monthlyRevenueIncrease = `$${isFinite(monthlyRevenueIncrease) ? monthlyRevenueIncrease : 0}k`;
  annualRevenueIncrease = `${isFinite(annualRevenueIncrease) ? annualRevenueIncrease : 0}%`;

  return [
    {
      title: 'ROI with ServiceTitan',
      value: roiWithST,
      active: false,
    },
    {
      title: 'Monthly Revenue Increase',
      value: monthlyRevenueIncrease,
      active: true,
    },
    {
      title: 'Annual Revenue Increase',
      value: annualRevenueIncrease,
      active: false,
    },
  ];
};
